
import Personalcard from "../../../assets/duotone/Personalcard.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function PersonalcardIcon({ className, dataTestid = "PersonalcardIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Personalcard data-testid={dataTestid} className={classes} {...rest} />
  );
}
